import React, { Component } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import autobind from 'autobind-decorator'
import { DragSource, DropTarget } from 'react-dnd'
import { getEmptyImage } from 'react-dnd-html5-backend'
import "whatwg-fetch"
import URL from 'url-parse';
import TInputForm from "../common/TInputForm"
import { changeSaveStatus, deleteLink, updateLink, moveLink, dropLink } from '../../actions/mylink'
import { jsonResponseHandler } from "../../utils/FetchHelper"
import * as SaveStatus from '../../constants/SaveStatus'
import { validate } from './MyLinkFormValidator'
import {addPrefix} from "../../utils/UriUtil";

@connect(state => ({
  links: state.link.my.links,
  saveStatus: state.link.my.saveStatus
}), dispatch => ({
  handleChangeSaveStatus(saveStatus) {
    dispatch(changeSaveStatus(saveStatus))
  },
  handleDelete: (index) => {
    dispatch(deleteLink(index))
  },
  handleUpdate: (link) => {
    dispatch(updateLink(link))
  },
  handleMove: (dragIndex, hoverIndex, isTemporary) => {
    dispatch(moveLink(dragIndex, hoverIndex, isTemporary))
  },
  handleDrop: (dragIndex) => {
    dispatch(dropLink(dragIndex))
  },
  dispatch
}))
@DragSource(
  'item',
  {
    beginDrag: (props, monitor, component) => ({
      index: props.index,
      item: props.item
    }),
    endDrag: (props, monitor, component) => {
      props.handleDrop(monitor.getItem().index)
    }
  },
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  })
)
@DropTarget(
  'item',
  {
    hover: (props, monitor, component) => {
      const dragIndex = monitor.getItem().index
      const hoverIndex = props.index

      if (dragIndex === hoverIndex) {
        return;
      }

      props.handleMove(dragIndex, hoverIndex, true)
      monitor.getItem().index = hoverIndex;
    }
  },
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget()
  })
)
class MyLinkListItem extends Component {

  constructor(props) {
    super(props);
    this.state = {
      edit: false,
      validated: false,
      faviconUrl: this.makeFaviconUrl(props.item),
      url: props.item.url,
      name: props.item.linkName
    }
  }

  componentDidMount() {
    const { connectDragPreview } = this.props
    connectDragPreview(getEmptyImage(), {
      captureDraggingState: true
    })
  }

  componentWillReceiveProps(props) {
    this.setState({
      faviconUrl: this.makeFaviconUrl(props.item)
    })
  }

  makeFaviconUrl(item) {
    const linkUrl = new URL(item.url);
    return linkUrl.origin + '/favicon.ico';
  }

  @autobind
  handleEditStart() {
    const { item, onEdit } = this.props
    onEdit(item.linkId)
  }

  @autobind
  handleEditEnd() {
    const { onEdit } = this.props
    onEdit(null)
  }

  @autobind
  handleSubmit(e) {
    const { url, name } = this.state;
    const { links, item, handleChangeSaveStatus, handleUpdate, dispatch, saveStatus } = this.props;

    e.preventDefault();
    if (!validate(name, url)) {
      return false
    }

    handleChangeSaveStatus(SaveStatus.DOING)

    fetch(addPrefix(`/manage/link/my/${item.linkId}.json`), {
      method: 'put',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        ordering: links.map(item => item.linkId),
        link: {
          name: name,
          url: url
        }
      })
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        handleUpdate(data)
        this.handleEditEnd()
      })
      .catch(e => {
        console.error(e)
        handleChangeSaveStatus(saveStatus)
      })

    return false
  }

  @autobind
  handleReset(e) {
    this.handleEditEnd()
  }

  @autobind
  handleDelete() {
    const { item, links, handleDelete, handleChangeSaveStatus,dispatch, saveStatus } = this.props

    handleChangeSaveStatus(SaveStatus.DOING)
    fetch(addPrefix(`/manage/link/my/${item.linkId}.json`), {
      method: 'delete',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        ordering: links.map(item => item.linkId)
      })
    })
      .then(jsonResponseHandler(dispatch))
      .then(() => {
        handleDelete(item.linkId)
      })
      .catch(e => {
        console.error(e)
        handleChangeSaveStatus(saveStatus)
      })
  }

  @autobind
  removeErrorFavicon(e) {
    this.setState({
      faviconUrl: null
    })
  }

  render() {
    const { item, connectDragSource, connectDropTarget, editLinkId } = this.props
    const { faviconUrl } = this.state

    const edit = editLinkId === item.linkId;

    return connectDropTarget(
      <div className={classnames("bundle_item", { "insert_item": item.isTemporary })}>
        <div className={classnames("item_order", { "item_edit": edit })}>
          { !edit &&
          <div className="basic_item">
            {connectDragSource(
              <div className="wrap_drag">
                <span className="ico_blog ico_drag" />
              </div>
            )}

            <span className="txt_name">
              <span className="txt_ellip">{item.linkName}</span>
              <a href={item.url} target="_blank" className="txt_url">{item.url}</a>
            </span>

            <div className="info_btn">
              <a href="#" className="btn_post" onClick={()=>this.handleEditStart()}>수정</a>
              <a href="#" className="btn_post" onClick={()=>this.handleDelete()}>삭제</a>
            </div>
          </div>
          }

          { edit &&
          <form className="edit_item type_double" onSubmit={this.handleSubmit} onReset={this.handleReset}>
            <label className="lab_tf">
              <strong className="screen_out"> 기존 주소명</strong>
              <TInputForm type="text" className="tf_blog" placeholder="url을 입력해주세요" value={this.state.url} onChange={(url) => this.setState({...this.state, url: url})} />
            </label>
            <label className="lab_tf">
              <strong className="screen_out">기존 링크명</strong>
              <TInputForm type="text" className="tf_blog" placeholder="Name" value={this.state.name} onChange={(name) => this.setState({...this.state, name: name})} />
            </label>
            <div className="order_btn">
              <button type="reset" className="btn_cancel">취소</button>
              <button type="submit" className="btn_default">확인</button>
            </div>
          </form>
          }

        </div>
      </div>
    )
  }
}

export default MyLinkListItem
